import { render, staticRenderFns } from "./MenuItemCreateForm.vue?vue&type=template&id=6925a4de&scoped=true&"
import script from "./MenuItemCreateForm.vue?vue&type=script&lang=js&"
export * from "./MenuItemCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925a4de",
  null
  
)

export default component.exports